import Menu from '../menu/Menu';

import '../menu/Menu.scss';

const Navbar = () => {
  return (
    <nav className="navbar">
      <Menu />
    </nav>
  );
};

export default Navbar;
